import { Injectable } from '@angular/core';
import { DecimalPipe } from "@angular/common";

@Injectable()
export class NumberFormatService {
    private readonly decimalFormat: string = '1.2-4';

    constructor(private pipe: DecimalPipe) {

    }

    public formatDecimal(value: number, format: string = this.decimalFormat) {
        return this.pipe.transform(value, format);
    }

}


// WEBPACK FOOTER //
// ./src/app/core/services/number-format.service.ts